/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export interface ToastMessageProps {
 message: string | null;
 type: 'info' | 'success' | 'warning' | 'error';
 id?: number;
}
export interface ToastState {
 messages?: ToastMessageProps[];
}

const initialState: ToastState = {
 messages: [],
 //  message: null,
 //  type: 'info',
};

const toastSlice = createSlice({
 name: 'toast',
 initialState,
 reducers: {
  displayToast(state, action: PayloadAction<ToastMessageProps>) {
   return {
    ...state,
    messages: [
     ...(<any>state.messages),
     {
      message: action.payload.message,
      type: action.payload.type,
      id: nanoid(),
     },
    ],
   };
  },
  clearToast(state, action: PayloadAction<any>) {
   return {
    ...state,
    messages: state.messages?.filter(
     (message) => message.id !== action.payload,
    ),
   };
  },
 },
});

export const { displayToast, clearToast } = toastSlice.actions;

export default toastSlice.reducer;
